import React from 'react'
import '../styles/Services.css'

export default function Services() {
    return (
        <>
            <div className="services pd">
                <div className="container">
                    <h3 className="title">Services</h3>
                    <div className="row">
                        <div className="col-md-3">
                            <div className="serv">
                                <img src="./images/solution.png"/>
                                <h5>Mind Improvement</h5>
                                <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="serv">
                                <img src="./images/video-tutorials.png"/>
                                <h5>E-learning</h5>
                                <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="serv">
                                <img src="./images/graduated.png"/>
                                <h5>Certificates</h5>
                                <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="serv">
                                <img src="./images/stopwatch.png"/>
                                <h5>Quizzes</h5>
                                <p>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
